<script>
import date from 'locutus/php/datetime/date'
import defaults from 'lodash/defaults'
import {
  fetchTicketType,
  createTicketType,
  updateTicketType,
} from '@apis/admin/cs'
import LangItem from '@components/admin/lang-input'
import FormEditor from '@components/admin/form-editor'

export default {
  components: { LangItem, FormEditor },
  props: {
    type_seq: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      params: {},
      info: null,
      loading: false,
      active_tab: 'info',
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      Promise.all([this.loadTicketType()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadTicketType() {
      const { type_info } = await fetchTicketType(this.type_seq)
      this.params = defaults(type_info, {
        title: '',
        name: '',
        seq: null,
        regdate: null,
        list_order: 0,
        use_content: 'N',
        allow_guest: 'N',
        use_notify_manager: 'N',
        use_notify: 'N',
      })
      this.info = type_info
    },
    handleSubmit() {
      const createOrUpdate = this.params.seq
        ? updateTicketType
        : createTicketType
      const confirm_message = this.params.seq
        ? this.$t('admin.msg_save')
        : this.$t('admin.msg_enroll')
      const success_message = this.params.seq
        ? this.$t('cs_ticket_type_info.msg_cs_type_modify')
        : this.$t('cs_ticket_type_info.msg_cs_type_register')

      this.loading = true
      this.$confirm(confirm_message, this.$t('admin.modal_confirm'))
        .then(() => createOrUpdate(this.params))
        .then(({ seq }) => this.$emit('submit', seq))
        .then(() => this.$toasted.success(success_message))
        .catch((e) => (e ? this.$toasted.error(e.message) : null))
        .finally(() => {
          this.loading = false
        })
    },
    date,
  },
}
</script>

<template>
  <el-tabs v-model="active_tab" :stretch="true">
    <el-tab-pane :label="$t('admin.default_info')" name="info">
      <form
        v-loading="loading"
        action="./"
        method="get"
        @submit.prevent="handleSubmit"
      >
        <table cellspacing="0" cellpadding="0" :class="$style.rowTable">
          <colgroup>
            <col width="20%" />
            <col width="30%" />
            <col width="20%" />
            <col width="30%" />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row"
                ><div>{{ $t('cs_ticket_type_info.title') }}</div></th
              >
              <td
                ><LangItem v-if="!loading" v-model="params.title"></LangItem
              ></td>
              <th scope="row"
                ><div>{{ $t('cs_ticket_type_info.name') }}</div></th
              >
              <td>
                <template v-if="params.seq">{{ params.name }}</template>
                <input
                  v-else
                  v-model="params.name"
                  type="text"
                  :class="[$style.inputTypeText]"
              /></td>
            </tr>
            <tr>
              <th scope="row"
                ><div>{{ $t('cs_ticket_type_info.list_order') }}</div></th
              >
              <td>
                <input
                  v-model="params.list_order"
                  type="text"
                  :class="[$style.inputTypeText, $style.w40, $style.tRight]"
              /></td>
              <th scope="row"
                ><div>{{ $t('cs_ticket_type_info.use_content') }}</div></th
              >
              <td>
                <ElSwitch
                  v-model="params.use_content"
                  active-value="Y"
                  inactive-value="N"
                ></ElSwitch
              ></td>
            </tr>
            <tr>
              <th scope="row"
                ><div>{{ $t('cs_ticket_type_info.allow_guest') }}</div></th
              >
              <td>
                <ElSwitch
                  v-model="params.allow_guest"
                  active-value="Y"
                  inactive-value="N"
                ></ElSwitch
              ></td>
              <th scope="row"
                ><div>{{ $t('cs_ticket_type_info.use_notify') }}</div></th
              >
              <td>
                <ElSwitch
                  v-model="params.use_notify"
                  active-value="Y"
                  inactive-value="N"
                ></ElSwitch
              ></td>
            </tr>
            <tr>
              <th scope="row"
                ><div>{{
                  $t('cs_ticket_type_info.use_notify_manager')
                }}</div></th
              >
              <td>
                <ElSwitch
                  v-model="params.use_notify_manager"
                  active-value="Y"
                  inactive-value="N"
                ></ElSwitch
              ></td>
            </tr>
            <tr>
              <th colspan="4" :class="$style.button">
                <span :class="[$style.button, $style.black]"
                  ><input
                    type="submit"
                    :value="params.seq ? $t('admin.save') : $t('admin.enroll')"
                /></span>
              </th>
            </tr>
          </tbody>
        </table>
      </form>
    </el-tab-pane>
    <el-tab-pane
      :disabled="!params.seq"
      :label="$t('admin.kyc_form')"
      name="CS_TICKET"
    >
      <FormEditor
        v-if="params.seq"
        target_type="CS_TICKET"
        :target_seq="params.seq"
      ></FormEditor>
    </el-tab-pane>
  </el-tabs>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
